import { dataHooks } from '../../../../libs/dataHooks';

export const megaMenuToggleDataHooks = dataHooks<{ label: {}; shortLabel: {} }>('mega-menu-toggle');
